<template>
  <div>
    <div class="container">
      <panel-selector :schema="schema" class="panel-selector" />

      <div class="columns">
        <div class="column">
          <filter-set :schema="schema" @filter-changed="onMetabaseFilterChange" />
        </div>
      </div>
    </div>
    <div class="columns iframe-container">
      <div class="column">
        <iframe
          v-resize="{}"
          scrolling="no"
          width="100%"
          :src="iframeUrl"
          allowfullscreen
          ref="metabaseEmbed"
          @load="onMetabaseLoaded"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import FilterSet from '@/components/FilterSet'
import PanelSelector from '@/components/PanelSelector'
import { encode } from 'querystring'
import { metabaseAbsoluteUrl } from '@/utils/metabase'
import rootSchema from '@/schema'

const URL_BASE = metabaseAbsoluteUrl('/public/dashboard/bba32808-4653-45d3-b794-403c1177942b')

export default {
  name: 'PanelCovid',
  components: {
    FilterSet,
    PanelSelector
  },
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      iframeUrl: URL_BASE,
      filtersRemoved: false
    }
  },
  computed: {
    paneles() {
      return Object.entries(rootSchema.properties)
    }
  },
  methods: {
    onMetabaseFilterChange({ url, params }) {
      const query = encode(params)

      this.iframeUrl = `${metabaseAbsoluteUrl(url)}?${query}`
    },
    onMetabaseLoaded() {
      let iframeWindow = this.$refs.metabaseEmbed.contentWindow
      let iframe = iframeWindow.document
      this.filtersRemoved = false

      // Stop trying to remove filters after 10s
      let filterRemotionTimeout = setTimeout(() => (this.filtersRemoved = true), 10000)

      let removeHeaders = () => {
        let frameHeader = iframe.getElementsByClassName('EmbedFrame-header')
        frameHeader = Array.prototype.slice.call(frameHeader)

        if (frameHeader.length === 0) {
          // Note that we cannot combine this !stop condition above
          if (!this.filtersRemoved) {
            iframeWindow.requestAnimationFrame(removeHeaders)
          }
        } else {
          frameHeader.forEach(header => {
            header.style.display = 'none'
          })

          this.filtersRemoved = true
          clearTimeout(filterRemotionTimeout)
        }
      }

      iframeWindow.requestAnimationFrame(removeHeaders)
    }
  }
}
</script>

<style scoped>
.panel-selector {
  margin-top: 1vh;
  margin-bottom: 2vh;
}

.iframe-container {
  margin-top: 1vh;
}
</style>
